/**
 * useSidebarState — small adapter over the legacy `appSettings`
 * slice so the new shell can share collapse/expand state with the
 * rest of the app (info pane width math in legacy Dashboard, etc.)
 * without forking the source of truth.
 *
 * Returns:
 *   - collapsed: boolean  (true when sidebar is in narrow rail mode)
 *   - toggle:    () => void
 */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleIsSideMenuPinned } from 'redux_store';

const useSidebarState = () => {
  const dispatch = useDispatch();
  const isPinned = useSelector(state => state.appSettings.isSideMenuPinned);
  const toggle = useCallback(() => {
    dispatch(toggleIsSideMenuPinned());
  }, [dispatch]);

  return { collapsed: !isPinned, toggle };
};

export default useSidebarState;
